import { useQuery } from "@tanstack/react-query";
import { getHabilitarMeStatus } from "../services/infractions.service";
import { infractionQueryKeys } from "./infraction-query-keys";

export function useHabilitarMeStatus() {
	return useQuery({
		queryKey: infractionQueryKeys.habilitarMeStatus(),
		queryFn: getHabilitarMeStatus,
	});
}
